//? Library Imports ------------------------------------------------------------>
import { Row, Col, Carousel, Typography } from "antd";

//? Assets --------------------------------------------------------------------->
import "./ProductsCarousel.scss";
import {
  SlickNextArrow,
  SlickPrevArrow,
} from "../Buttons/CarouselButtons/CarouselButtons";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

//? Modules -------------------------------------------------------------------->
import ProductCard from "./ProductCard/ProductCard";
import { useEffect, useState } from "react";
import CustomSkeletonBox from "@/components/CustomSkeletonBox/CustomSkeletonBox";
import Link from "next/link";
import FashionProductCard from "@/components/fashion/common/FashionProductCard";

//? Library Constants ---------------------------------------------------------->
const { Text } = Typography;

const FashionNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} fashion-carousel-arrow fashion-carousel-arrow--next`}
      style={{ ...style, display: "block", zIndex: "1" }}
      onClick={onClick}
    >
      <ArrowForwardIosIcon />
    </div>
  );
};

const FashionPrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} fashion-carousel-arrow fashion-carousel-arrow--prev`}
      style={{ ...style, display: "block", zIndex: "1" }}
      onClick={onClick}
    >
      <ArrowBackIosIcon />
    </div>
  );
};

export default function ProductsCarousel({
  categoryName,
  data,
  title,
  userAgent,
  type,
  buttonText,
  buttonLink,
  buttonColor,
  useFashionCard = false, // New prop to determine card type
  currency = "PKR",
}) {
  //? Hooks ---------------------------------------------------------------------->
  const [loading, setLoading] = useState(true);
  const { isMobile, isDesktop } = userAgent;
  //let noOfSlides = products?.products?.length > 5 ? true : false;
  const settings = {
    swipe: true,
    dots: false,
    autoplay: false,
    infinite: false,
    arrows: useFashionCard ? true : !isMobile,
    slidesToShow: isDesktop
      ? useFashionCard ? 4 : 5
      : useFashionCard ? 2 : 2.2,
    slidesToScroll: isDesktop ? 1 : useFashionCard ? 2 : 2,
    prevArrow: useFashionCard ? <FashionPrevArrow /> : <SlickPrevArrow />,
    nextArrow: useFashionCard ? <FashionNextArrow /> : <SlickNextArrow />,
  };

  const productCount = data?.length || 0;
  // Few items stretch/break slick layout — show static cards instead of carousel
  const showStaticCards = productCount > 0 && productCount <= 3;

  useEffect(() => {
    if (data?.length) {
      setLoading(false);
    }
  }, [data]);

  return (
    <Row
      align="middle"
      justify="center"
      className={
        !isDesktop
          ? "ProductsCarousel products-carousel-container padding0"
          : "ProductsCarousel padding0 products-carousel-container"
      }
    >
      {/* {title ? (
        <Col
          span={24}
          className="sectionHeadingContainer side-bullet text-center mt-10 mb-10"
        >
          <Text
            className={
              isDesktop
                ? "sectionHeadingBold"
                : "sectionHeadingMobileBold textCenter"
            }
          >
            {title}
          </Text>
        </Col>
      ) : null} */}
      {title ? (
        <Col
          span={24}
          className={`sectionHeadingContainer mb-10 ${useFashionCard ? "sectionHeadingContainer--fashion" : "mt-10"
            }`}
        >
          {/* <Col span={24} className={`sectionHeadingContainer mt-10 mb-10${useFashionCard ? " sectionHeadingContainer--fashion" : ""}`}> */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "left",
            }}
          >
            <Text
              className={
                isDesktop ? "sectionHeadingBold" : "sectionHeadingMobileBold"
              }
            >
              {title}
            </Text>

            {isDesktop && buttonText && buttonLink && buttonColor ? (
              <div className="products-carousel-button">
                <Link
                  href={`${buttonLink}${buttonLink.includes("?") ? "&" : "?"
                    }popup=true`}
                  style={{ color: `${buttonColor} !important` }}
                >
                  {buttonText}
                </Link>
              </div>
            ) : null}
          </div>
        </Col>
      ) : null}

      <Col span={24}>
        <div
          className={[
            "carousel_container",
            !isDesktop && !useFashionCard ? "paddingLeft5" : "",
            useFashionCard ? "products-carousel-container--fashion" : "",
          ]
            .filter(Boolean)
            .join(" ")}
        >
          {loading ? (
            <div style={{ display: "flex" }}>
              {isMobile ? (
                <>
                  {[1, 2].map((index) => (
                    <div key={index} style={{ flex: 1, marginRight: 16 }}>
                      <CustomSkeletonBox width="100%" height={250} />
                    </div>
                  ))}
                </>
              ) : (
                <>
                  {[1, 2, 3, 4, 5].map((index) => (
                    <div key={index} style={{ flex: 1, marginRight: 16 }}>
                      <CustomSkeletonBox width="100%" height={371} />
                    </div>
                  ))}
                </>
              )}
            </div>
          ) : showStaticCards ? (
            // ≤3 products: static cards (carousel layout breaks with few items)
            <div
              className={`products-carousel__grid-fallback products-carousel__grid-fallback--count-${productCount}${
                useFashionCard ? " products-carousel__grid-fallback--fashion" : ""
              }`}
            >
              {data.map((pro, key) => (
                <div
                  key={key}
                  className={
                    useFashionCard
                      ? "products-carousel__slide-fashion"
                      : "products-carousel__static-card"
                  }
                >
                  {useFashionCard ? (
                    <FashionProductCard
                      product={pro}
                      userAgent={userAgent}
                      currency={currency}
                    />
                  ) : (
                    <ProductCard
                      type={type}
                      product={pro}
                      categoryName={categoryName}
                      userAgent={userAgent}
                    />
                  )}
                </div>
              ))}
            </div>
          ) : (
            <Carousel {...settings}>
              {data?.length &&
                data?.map((pro, key) => {
                  return (
                    <div
                      key={key}
                      className={
                        useFashionCard
                          ? "products-carousel__slide-fashion"
                          : "padding5"
                      }
                    >
                      {useFashionCard ? (
                        <FashionProductCard
                          product={pro}
                          userAgent={userAgent}
                          currency={currency}
                        />
                      ) : (
                        <ProductCard
                          type={type}
                          product={pro}
                          categoryName={categoryName}
                          userAgent={userAgent}
                        />
                      )}
                    </div>
                  );
                })}
            </Carousel>
          )}
        </div>
        {!isDesktop && buttonText && buttonLink && buttonColor ? (
          <div className="products-carousel-mobile-button">
            <Link
              href={`${buttonLink}${buttonLink.includes("?") ? "&" : "?"
                }popup=true`}
              style={{ color: `${buttonColor} !important` }}
            >
              {buttonText}
            </Link>
          </div>
        ) : null}
      </Col>
    </Row>
  );
}
